import DashboardTitleComponent from "../../custom/DashboardTitleComponent";
import React, { useEffect, useState } from "react";
import {
  Typography,
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Menu, MenuItem
} from "@mui/material";
import CustomAutocompleteField from "../../custom/CustomAutoCompleteField";
import CustomIconButton from "../../custom/CustomIconButton";
import CustomTextField from "../../custom/CustomTextField";
import CustomButton from "../../custom/CustomButton";
import { isBlank } from "../../../utils/ValidationRules";
import CustomDataGrid from "../../custom/CustomDataGrid";
import { useUser } from "../../../pages/UserContext";
import { showSuccessToast, showErrorToast } from "../../../utils/swalToast";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { MoreVert as MoreVertIcon } from "@mui/icons-material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import apiClient from "../../../utils/apiClient";

const JenisIuranMenu = () => {
  const userDetails = useUser();

  // Form state
  const [listPembayaran, setListPembayaran] = useState("");
  const [jenisIuran, setJenisIuran] = useState("");
  const [vaCode, setVaCode] = useState("");
  const [biaya, setBiaya] = useState("");
  const [listPembayaranItems, setListPembayaranItems] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);

  const [open, setOpen] = useState(false);
  const [openAddMaster, setAddOpenMaster] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiClient.get("/master-pembayaran-iuran");
        setListPembayaranItems(
          response.data.data.map((item) => ({
						id: item.id,
            uuid: item.uuid,
            name: item.name,
            biaya: item.biaya,
            vaCode: item.va_code
          }))
        );
      } catch (error) {
        alert("Error fetching payment options", error);
      } finally {
        setTableLoading(false);
      }
    };
    fetchData();
  }, [refresh]);

  const handleOpenMasterModal = () => {
    setAddOpenMaster(true);
  };

  const handleCloseMasterModal = () => {
    setAddOpenMaster(false);
  };

  const handleOpenModal = () => {
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
    setListPembayaran("");
    setSelectedFile(null);
    setPreviewImage(null);
  };

  const handleAddMasterIuran = async () => {
    if (!jenisIuran) {
      return showErrorToast("Harap isi jenis iuran yang ingin dibuat");
    }

    if (!biaya) {
      return showErrorToast("Harap isi biaya iuran yang ingin dibuat");
    }

    if (!vaCode) {
      return showErrorToast("Harap isi kode VA yang ingin dibuat");
    }
  
    const requestData = {
      jenisIuran: jenisIuran,
      biaya: biaya,
      vaCode: vaCode,
    };
  
    try {
      setLoading(true);

      await apiClient.post("/master-pembayaran-iuran", requestData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      showSuccessToast("Penambahan master iuran berhasil dibuat");

      setJenisIuran(null);
      setBiaya(null);
      setVaCode(null);
      setAddOpenMaster(false);
      setRefresh((prev) => !prev);
    } catch (error) {
      showErrorToast("Terjadi kesalahan saat mengajukan pembayaran.");
    } finally {
      setLoading(false);
    }
  }

  const columns = [
    { field: "id", headerName: "No.", flex: 1 },
    { field: "name", headerName: "Nama Iuran", flex: 1 },
    { field: "biaya", headerName: "Biaya", flex: 1 },
    { field: "vaCode", headerName: "Kode VA", flex: 1 },
  ];

  return (
    <div>
      <DashboardTitleComponent text={"Jenis Iuran"} />
      <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
        {userDetails.role === "admin" && (
          <CustomButton
            onClick={handleOpenMasterModal}
            text="Tambah Jenis Iuran"
            isFullWidth={false}
            baseColor="#003158"
            hoverColor="#00213A"
						width={200}
          />
        )}
      </div>
      <div style={{ height: "10px" }}></div>
			<div>
				<CustomDataGrid rows={listPembayaranItems} columns={columns} loading={tableLoading} />
			</div>

      {userDetails.role === "admin" && (
        <Dialog
          open={openAddMaster}
          onClose={handleCloseMasterModal}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle>Penambahan Jenis Iuran</DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={2}>
              <Grid item md={4} xs={12}>
                <Typography>
                  Jenis Iuran<span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomTextField
                  value={jenisIuran}
                  onChange={(event) => setJenisIuran(event.target.value)}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <Typography>
                  Biaya<span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomTextField
                  value={biaya}
                  onChange={(event) => setBiaya(event.target.value)}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <Typography>
                  Kode VA<span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomTextField
                  value={vaCode}
                  onChange={(event) => setVaCode(event.target.value)}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <CustomButton
              onClick={handleCloseMasterModal}
              text="Cancel"
              isFullWidth={false}
              baseColor="#A92027"
              hoverColor="#8C1016"
            />
            <CustomButton
              onClick={handleAddMasterIuran}
              text="Submit"
              isFullWidth={false}
              baseColor="#003158"
              hoverColor="#00213A"
            />
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
};

export default JenisIuranMenu;
